module.exports = __webpack_public_path__ + "img/weary-cat.40221775.png";